import builder from '../builder';
import MessagesBubbleSquareTextAlternate from '../../streamline-icons/bold/messages-bubble-square-text-alternate.svg';

export default builder(
  'IconMessagesBubbleSquareTextAlternateBold',
  MessagesBubbleSquareTextAlternate,
);
